import splide from "../utils/splide";
require("fslightbox");

export default function gallery(perPage = 4) {
    const gallery = document.getElementById("gallery");
    if (gallery) {
        const gallerySplide = splide(gallery, {perPage});
        gallerySplide.mount();
    }
}
